// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3kk4g","header":"Messages_header__byITL"};